export enum ApiVersion {
    FirstVersion = 1,
    MultipleContainerSelect = 2,
    FsTerminalSupport = 3,
    MultiRegistrationLocations = 4,
    DeviceRegistrationSupport = 5,
    GetUserInformationSupport = 6,
}

export const defaultApiVersion = ApiVersion.FirstVersion;
export const minimalSupportedApiVersion = ApiVersion.GetUserInformationSupport;
